<template>
  <el-dialog
    :title="selectedItemId === null ? '新增錄音流通' : '編輯錄音流通'"
    :visible.sync="innerVisible"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <!--<el-form-item label="單位" :label-width="formLabelWidth">-->
      <!--<el-input :value="myownOrg" readonly autocomplete="off"></el-input>-->
      <!--</el-form-item>-->

      <el-form-item label="名稱" :label-width="formLabelWidth" prop="name">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>

      <!--<el-form-item-->
      <!--label="管理員"-->
      <!--:label-width="formLabelWidth"-->
      <!--prop="adminIds" >-->
      <!--<el-select-->
      <!--v-model="form.adminIds"-->
      <!--multiple-->
      <!--placeholder="请选择"-->
      <!--filterable >-->
      <!--<el-option-->
      <!--v-for="item in users"-->
      <!--:key="item.id"-->
      <!--:label="`${item.username}(${item.name})`"-->
      <!--:value="item.id" >-->
      <!--</el-option>-->
      <!--</el-select>-->
      <!--</el-form-item>-->

      <el-form-item label="備註" :label-width="formLabelWidth">
        <el-input type="textarea" v-model="form.memo"></el-input>
      </el-form-item>

      <el-form-item label="顏色" :label-width="formLabelWidth" prop="color">
        <div style="width:480px;marginBottom:-20px">
          <el-radio-group v-model="form.color">
            <el-radio
              v-for="itemColor in extTagColorList"
              :key="itemColor.name"
              :label="itemColor.name"
            >
              <span :style="{ color: itemColor.textColor }">
                {{ itemColor.txtLabel }}
              </span>
            </el-radio>
          </el-radio-group>
        </div>
      </el-form-item>

      <el-form-item label="需要審核" :label-width="formLabelWidth">
        <el-switch
          v-model="form.isNeedApprove"
          active-text="是"
          inactive-text="否"
        ></el-switch>
      </el-form-item>
      <el-divider content-position="left">於系統自動刪除設定</el-divider>
      <el-form-item
        label="自動刪除"
        :label-width="formLabelWidth"
        prop="isAssetExpiration"
      >
        <el-switch
          v-model="form.isAssetExpiration"
          active-text="啟用"
          inactive-text="關閉"
        >
        </el-switch>
      </el-form-item>
      <el-form-item
        label="上傳後"
        :label-width="formLabelWidth"
        prop="assetExpirationDateAmount"
      >
        <el-input-number
          v-model="form.assetExpirationDateAmount"
          :min="1"
          :max="999"
        >
        </el-input-number>
        <el-select v-model="form.assetExpirationDateUnit" placeholder="單位">
          <el-option label="日" value="days"></el-option>
           </el-select
        >刪除
      </el-form-item>
      <el-divider content-position="left">下載設定</el-divider>
      <el-form-item label="加密" :label-width="formLabelWidth" prop="isEncrypt">
        <el-switch
          v-model="form.isEncrypt"
          active-text="啟用"
          inactive-text="關閉"
        >
        </el-switch>
      </el-form-item>
      <el-form-item
        label="失效日模式"
        :label-width="formLabelWidth"
        prop="encryptExpiredMode"
      >
        <el-switch
          :disabled="!form.isEncrypt"
          v-model="form.encryptExpiredMode"
          active-value="absolute"
          inactive-value="relative"
          active-text="指定日期"
          inactive-text="相對日期"
        >
        </el-switch>
      </el-form-item>
      <el-form-item
        v-if="form.encryptExpiredMode == 'absolute'"
        label="失效日"
        :label-width="formLabelWidth"
        prop="endDate"
      >
        <el-date-picker
          :disabled="!form.isEncrypt"
          v-model="form.endDate"
          :picker-options="pickerOptions"
          :clearable="false"
          type="date"
          value-format="timestamp"
          placeholder="指定失效日"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item
        v-if="form.encryptExpiredMode == 'relative'"
        label="下載後"
        :label-width="formLabelWidth"
        prop="endDate"
      >
        <el-input-number
          :disabled="!form.isEncrypt"
          v-model="form.endDateAmount"
          :min="1"
          :max="999"
        >
        </el-input-number>
        <el-select
          v-model="form.endDateUnit"
          :disabled="!form.isEncrypt"
          placeholder="單位"
        >
          <el-option label="日" value="days"></el-option>
           </el-select
        >失效
      </el-form-item>
    </el-form>
    <template #footer class="dialog-footer">
      <el-button @click="innerVisible = false">取 消</el-button>
      <el-button type="primary" @click="submit">確 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment-timezone";
import { MAX_DUEDATE, NO_DATE } from "../../appConfig";
import tagColorsMixin from "@/components/mixin/tagColors.js";
export default {
  mixins: [tagColorsMixin],
  model: {
    prop: "visible",
    event: "toggleVisible",
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    selectedItemId: {
      type: Number,
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      myownOrg: "auth/orgName",
      //users: "user/users",
    }),
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("toggleVisible", val);
      },
    },
  },
  data() {
    return {
      rules: {
        name: [{ required: true, message: "請輸入部門名稱", trigger: "blur" }],
        //adminIds: [
        //{ required: true, message: "請選擇管理員", trigger: "blur" },
        ////{ validator: validatePass, trigger: 'blur' },
        //],
        color: [{ required: true, message: "請輸入顏色", trigger: "blur" }],
      },
      formLabelWidth: "100px",
      form: {
        name: "",
        memo: "",
        //adminIds: [],
        color: "primary",

        isNeedApprove: false,
        isAssetExpiration: true,
        assetExpirationDateAmount: 30,
        assetExpirationDateUnit: "days",
        encryptExpiredMode: "absolute",
        isEncrypt: false,
        endDate: MAX_DUEDATE,
        endDateAmount: 0,
        endDateUnit: "days",
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > MAX_DUEDATE;
        },
        shortcuts: [
          {
            text: "不限制",
            onClick(picker) {
              const date = MAX_DUEDATE;
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周後",
            onClick(picker) {
              const m = moment()
                .startOf("day")
                .add(1, "weeks")
                .valueOf();
              const date = new Date(m);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一個月後",
            onClick(picker) {
              const m = moment()
                .startOf("day")
                .add(1, "months")
                .valueOf();
              const date = new Date(m);
              picker.$emit("pick", date);
            },
          },
          {
            text: "三個月後",
            onClick(picker) {
              const m = moment()
                .startOf("day")
                .add(3, "months")
                .valueOf();
              const date = new Date(m);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一年後",
            onClick(picker) {
              const m = moment()
                .startOf("day")
                .add(1, "years")
                .valueOf();
              const date = new Date(m);
              picker.$emit("pick", date);
            },
          },
        ],
      },
    };
  },
  created() {
    if (this.innerVisible) {
      if (this.selectedItemId !== null) {
        const data = this.$store.getters["recshare/getRecshareById"](
          this.selectedItemId
        );
        this.form.id = data.id;
        this.form.name = data.name;
        this.form.memo = data.memo;
        this.form.isNeedApprove = data.isNeedApprove;
        this.form.isEncrypt = data.isEncrypt;
        this.form.encryptExpiredMode = data.encryptExpiredMode;
        this.form.endDate = data.endDate;
        this.form.endDateAmount = data.endDateAmount;
        this.form.endDateUnit = data.endDateUnit;
        this.form.assetExpirationDateAmount = data.assetExpirationDateAmount;
        this.form.assetExpirationDateUnit = data.assetExpirationDateUnit;
        this.form.isAssetExpiration = data.isAssetExpiration;
        //this.form.adminIds = data.admins.map(admin => admin.id);
        this.form.color = data.color;
      }
    }
  },
  methods: {
    submit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.selectedItemId !== null) {
            this.submitUpdate();
          } else {
            this.submitAdd();
          }
        } else {
          return false;
        }
      });
    },
    submitAdd() {
      //console.log(
      //`submitAdd: adminIds = ${JSON.stringify(this.form.adminIds)}`
      //);
      this.$store.dispatch("recshare/add", this.form).then(() => {
        this.innerVisible = false;
        this.$store.dispatch("recshare/list", null);
      });
    },
    submitUpdate() {
      this.$store.dispatch("recshare/update", this.form).then(() => {
        this.innerVisible = false;
        this.$store.dispatch("recshare/list", null);
      });
    },
  },
};
</script>

<style></style>
